import { INIT_SIDEBAR, SHOW_SIDEBAR, SHOW_SIDEBAR_COLLAPSE } from '../actions/types/index';

const INITIAL_STATE = {
  sidebarShow: false,
  sidebarCollapse: true
};
export default function sideBarReducer(state = INITIAL_STATE, action) {
  switch (action.type) {
    case SHOW_SIDEBAR_COLLAPSE:
      return { ...state, sidebarCollapse: action.payload };
    case SHOW_SIDEBAR:
      return { ...state, sidebarShow: action.payload };
    case INIT_SIDEBAR:
      return { ...INITIAL_STATE };
    default:
      return state;
  }
}
